<template>
    <div class="fhv-centent">
        <h4 class="title-topic">2.4G Wifi Neighbor</h4>
        <el-table :data="wlan1Neighbor" border style="width: 100%" class="fhv-table" size="mini" v-loading="isLoadWlan1">
            <el-table-column  prop="ssid" label="SSID" >
            </el-table-column>
            <el-table-column prop="bssid"  label="BSSID" >
            </el-table-column>
            <el-table-column prop="channel" label="Channel" width="80">
            </el-table-column>
            <el-table-column prop="signal" label="Signal(%)" width="85">
            </el-table-column>
            <el-table-column  prop="security" label="Security">
            </el-table-column>
            <el-table-column prop="mode"  label="Wireless Mode">
            </el-table-column>
        </el-table>
        <div class="fhv-scan">
            <el-button :loading="isLoadWlan1" type="primary" @click="search(1)">Scan</el-button>
        </div>
        <h4 class="title-topic">5G Wifi Neighbor</h4>
        <el-table :data="wlan0Neighbor" border style="width: 100%" class="fhv-table" size="mini"  v-loading="isLoadWlan0">
            <el-table-column  prop="ssid" label="SSID" >
            </el-table-column>
            <el-table-column prop="bssid"  label="BSSID" >
            </el-table-column>
            <el-table-column prop="channel" label="Channel" width="80">
            </el-table-column>
            <el-table-column prop="signal" label="Signal(%)" width="85">
            </el-table-column>
            <el-table-column  prop="security" label="Security">
            </el-table-column>
            <el-table-column prop="mode"  label="Wireless Mode">
            </el-table-column>
        </el-table>
        <div class="fhv-scan">
            <el-button :loading="isLoadWlan0" type="primary" @click="search(0)">Scan</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoadWlan1:false,
            isLoadWlan0:false,
            wlan1Neighbor: [], //2.4G
            wlan0Neighbor: [] //5G
        }
    },
    methods:{
        search(wlIndex){
            if(wlIndex == 1)
                this.isLoadWlan1 = true
            else
                this.isLoadWlan0 = true
            axios
            .post("/boafrm/fhWlanNeighbor",{CmdType:"GET_WLAN"+ wlIndex +"_NEIGHBOR"})
            .then((response)=>{
                if(wlIndex == 1)
                    this.isLoadWlan1 = false
                else
                    this.isLoadWlan0 = false

                if(response.data.ret === 0)
                {
                    if(wlIndex == 1)
                        this.wlan1Neighbor = response.data.wlanNeighbor
                    else if(wlIndex == 0)
                        this.wlan0Neighbor = response.data.wlanNeighbor
                }
                else
                {
                    this.$message.error(`search Wifi Neighbor faild!Error:${ response.data.errMsg} `)
                }
                
            })
            
        },
    }
}
</script>

<style>
.fhv-scan{
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>
